import { render } from 'preact'

import { Board } from '@/core/Board'
import { game } from '@/core/Game'
import { SideBar } from '@/interface/SideBar'
import { getAccessToken, refreshSession, signout } from '@/libs/AuthClient'
import { webSocketClient } from '@/libs/WebSocketClient'
import { AuthScreen } from '@/screens/AuthScreen'
import { ensureQuerySelector } from '@/utils/ensureQuerySelector'

import './index.css'

const $board = ensureQuerySelector<HTMLCanvasElement>('#board')
const $overlay = ensureQuerySelector<HTMLCanvasElement>('#overlay')
const $interface = ensureQuerySelector<HTMLDivElement>('#interface')
const $auth = ensureQuerySelector<HTMLDivElement>('#auth')

let board: Board | null = null

function showAuthScreen() {
  $auth.style.display = ''
  render(<AuthScreen onAuthenticated={startGame} />, $auth)
}

async function startGame() {
  render(null, $auth)
  // The overlay container itself would keep covering the viewport.
  $auth.style.display = 'none'

  if (!board) {
    board = new Board($board, $overlay)

    const token = getAccessToken()
    if (!token) {
      game.error.value = 'Missing access token — please sign in again.'

      return
    }

    try {
      await webSocketClient.connect(token)
      await game.new(board)
    } catch (err) {
      console.warn(err)
      game.error.value = 'Could not reach the server — please reload.'
    }
  }
  render(<SideBar board={board} onSignout={handleSignout} />, $interface)
}

async function handleSignout() {
  await signout()
  render(null, $interface)
  showAuthScreen()
}

if (await refreshSession()) {
  await startGame()
} else {
  showAuthScreen()
}
